import { IReqACHExceptionRulesPayload } from 'src/app/features/feature-transaction-rules/ach-exception-rules/landing-exception-rule/useACHExceptionRule'
import { IEditACHExceptionRuleModel } from '../models/ACHExceptionRule.model'
import customAxios from '../utils/api-util/customAxios'
import axiosInstance from '../utils/api-util/utilApi'

const config = { baseURL: process.env.REACT_APP_CLIENT_SETUP_SERVICE_URL || '' }

export const getAccountListByClientList = (payload: any) => {
  return axiosInstance.post(`/api/ACHExceptionRule/GetAccountsByClientsWithUser`, JSON.stringify(payload), config)
}

export const getClientList = () => {
  return axiosInstance.get(`/api/ACHExceptionRule/GetListClientName`, config)
}

export const postAddACHExceptionRule = (payload: any) => {
  return axiosInstance.post(`/api/ACHExceptionRule/Add`, JSON.stringify(payload), config)
}

export const putUpdateACHExceptionRule = (payload: IEditACHExceptionRuleModel) => {
  return axiosInstance.put(`/api/ACHExceptionRule/Update`, JSON.stringify(payload), config)
}

export const getExceptionRuleNewDetail = () => {
  return axiosInstance.get(`/api/ACHExceptionRule/GetNewModel`, config)
}

export const getExceptionRuleViewDetail = (ruleId: string) => {
  return axiosInstance.get(`/api/ACHExceptionRule/GetDetail/${ruleId}`, config)
}

export const getExceptionRuleEditDetail = (ruleId: string) => {
  return axiosInstance.get(`/api/ACHExceptionRule/GetEditModel/${ruleId}`, config)
}

export const getSecCode = () => {
  return axiosInstance.get(`/api/ACHExceptionRule/GetSECCodes`, config)
}

export const getACHExceptionRuleList = (payload: IReqACHExceptionRulesPayload) => {
  return axiosInstance.post(`/api/ACHExceptionRule/Filter`, JSON.stringify(payload), config)
}

export const getACHClientList = () => {
  return axiosInstance.get(`/api/ACHExceptionRule/GetListClientName`, config)
}

export const deleteACHExceptionRuleList = (id: string) => {
  return axiosInstance.delete(`/api/ACHExceptionRule/Delete/${id}`, config)
}

export const bulkDeleteACHExceptionRuleList = (ids: Array<string>) => {
  return axiosInstance.delete(`/api/ACHExceptionRule/bulk-deletion`, {
    data: {
      ids: ids,
    },
    ...config,
  })
}

export const downloadFileACHExceptionRulesTemplate = () => {
  return axiosInstance.get(`/api/ACHExceptionRule/DownloadTemplate`, config)
}

export const uploadXlsxFileACHExceptionRule = (formData: any) => {
  return customAxios('multipart/form-data').post(`/api/ACHExceptionRule/Upload`, formData, {
    ...config,
  })
}

export const saveUploadACHRules = (payload: any) => {
  return axiosInstance.post(`/api/ACHExceptionRule/Save`, JSON.stringify(payload), config)
}

export const downloadErrorFile = (fileName: string) => {
  return axiosInstance.get(`/api/ACHExceptionRule/DownloadFile/${fileName}`, config)
}

export const getACHExceptionRuleDownloadStatus = (fileId: string) => {
  return axiosInstance.get(`/api/ACHExceptionRule/getStatus/${fileId}`, config)
}

export const getACHExceptionRuleDownloadFile = (fileId: string) => {
  return axiosInstance.get(`/api/ACHExceptionRule/downloadPdf/${fileId}`, config)
}